import JobListShowMore from './job_list_show_more'
import RegistrationTeaser from '../registration_teaser'
import { bind as fenceBind } from '../registration_fence'

export default ($context = document) => {
  $(() => {
    $('.js-job-list', $context).map(function () {
      new JobListShowMore($(this), $('.js-jobs-show-more', $context))
    })

    $.each($('.js-registration-teaser'), function (index, value) {
      new RegistrationTeaser($(value), index)
    })
  })

  fenceBind()
}
